import { baseApi } from "../baseApi";

export const salesInvoiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSalesInvoiceDoc: builder.mutation({
      query: ({ doctype, name }) => ({
        url: `/api/method/frappe.desk.form.load.getdoc?doctype=${doctype}&name=${name}`,
        method: 'GET',
      }),
    }),

    deliveryNoteMapDoc: builder.mutation({
      query: (deliveryNoteId) => ({
        url: `/api/method/frappe.model.mapper.make_mapped_doc`,
        method: 'POST',
        body: {
          method: "erpnext.stock.doctype.delivery_note.delivery_note.make_sales_invoice",
          source_name: deliveryNoteId,
          selected_children: {},
        },
      }),
    }),
        createSalesInvoiceFromDN: builder.mutation({
      query: ({ delivery_note_id }) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_sales_invoice_from_dn`,
        method: 'POST',
        body: {
          delivery_note_id,
        },
      }),
    }),

        updateSalesInvoice: builder.mutation({
      query: ({ sales_invoice_id, items }) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_sales_invoice`,
        method: 'POST',
        body: {
          sales_invoice_id,
          items,
        },
      }),
    }),

        submitSalesInvoice: builder.mutation({
      query: ({ sales_invoice_id }) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.submit_sales_invoice`,
        method: 'POST',
        body: {
          sales_invoice_id,
        },
      }),
    }),
        getSalesInvoiceList: builder.mutation({
      query: ({ start, page_length, search_input }) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_sales_invoice_list`,
        method: 'POST',
        body: {
          start,
          page_length,
          search_input,
        },
      }),
    }),


    getSalesInvoiceCount: builder.query({
      query: () => ({
        url: `/api/method/frappe.desk.reportview.get_count`,
        params: {
          doctype: 'Sales Invoice',
        },
      }),
    }),

  }),
});

export const {
  useGetSalesInvoiceDocMutation,
  useDeliveryNoteMapDocMutation,
  useCreateSalesInvoiceFromDNMutation,
  useUpdateSalesInvoiceMutation,
  useSubmitSalesInvoiceMutation,
  useGetSalesInvoiceListMutation,
  useGetSalesInvoiceCountQuery
} = salesInvoiceApi;
